<template>
    <div o-Container o-Container-App>
        <div class="header-nav">
            <header-nav title="我的"></header-nav>
        </div>
        <div class="content">
            <div class="top-bg">
                <div @click="toLogin" class="top-content">
<!--                    <div :style="{backgroundImage: userInfo['avatarUrl'] && `url(${userInfo.avatarUrl})`}" class="avatar"></div>-->
                    <div class="avatar"></div>
                    <div class="mobile">{{octopus.passport.mobile  || '点击登录账户'}}</div>
                </div>
            </div>
            <div class="mask-bg">
                <div class="mask-money">
                    <div class="money-left">
                        <div class="lib">钱包余额</div>
                        <div class="money">¥{{Balance}}</div>
                    </div>
                    <div @click="toQianbao" class="see">查看</div>
                </div>
                <div @click="toCardManager" class="card-content">
                    <div class="card-left">
                        <div class="card">
                            <div class="card-manger">电卡管理</div>
                            <div class="card-infor">线上线下电卡一键管理</div>
                        </div>
                    </div>
                    <div class="card-right">
                        <van-icon name="arrow" size="14px" color="#fff" />
                    </div>
                </div>
            </div>
            <div class="font ad">
                <div class="font-title">加盟合作</div>
                <div class="ad-content"></div>
            </div>
            <div class="font icon-commnd">
                <div style="padding-left: 8px" class="font-title">更多推荐</div>
                <div class="icon-content">
                    <div v-for="(v,i) in iconList" :key="i" class="item">
                        <div @click="toPage(v)" class="iconfont" :class="v.iconClass"></div>
                        <span @click="toPage(v)">{{v.iconName}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-nav">
            <bottom-nav></bottom-nav>
        </div>
    </div>
</template>

<script>
import BottomNav from '@/components/Engine/FrameworkAPPLET/MenuEngine';
import HeaderNav from '@/components/Engine/FrameworkAPPLET/HeaderEngine';
export default {
    name: "mms_engine_database_item", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    components: { BottomNav,HeaderNav },
    data() {
        return {
            Balance: 0,
            octopus: this.$parent.octopus,
            userInfo: {},
            isLogin: false,
            iconList: [{
                iconClass: 'iconweixiu1',
                iconName: '故障报修',
                href: "TroubleShooting",
            },{
                iconClass: 'iconzhiliangguanli',
                iconName: '常见问题',
                href: "CommonProblem",
            },{
                iconClass: 'iconzhanghaoguanli1',
                iconName: '账号管理',
                href: "Logout",
            },{
                iconClass: 'iconfankui1',
                iconName: '意见反馈',
                href: "Feedback",
            }],
        }
    },
    activated() {
        if (window.my) {
            my.onMessage = e => {
                this.getMoney();
            }
        }
        this.$nextTick(() => { //延迟加载
            this.contentHeight(); //动态设置高度
            window.addEventListener('resize',this.contentHeight);
        });
        if (window.localStorage.getItem('userInfo')) { //用户信息
            this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
        }
        document.title = '我的'; //动态设置title
        if (this.octopus.passport.token) {
            this.isLogin = true;
            this.getMoney();
        } else {
            this.isLogin = false;
        }
    },
    methods: {
        async toPage(item) {
            let isLogin = await this.octopus.applet.noLoginToPage(this);
            if (!isLogin) return;
            this.octopus.router.jump(`/pages/webView/index?webViewUrl=/Applet/Chargingpile/${item.href}/Page`); //跳转
        },
        async toLogin() {
            let isLogin = await this.octopus.applet.noLoginToPage(this);
            if(this.octopus.passport.mobile){
                this.octopus.router.jump(`/pages/webView/index?webViewUrl=/Applet/Chargingpile/UserInformation/Page`); //跳转
            }
        },
        async toCardManager() {
            let isLogin = await this.octopus.applet.noLoginToPage(this);
            if (!isLogin) return;
            this.octopus.router.jump('/pages/webView/index?webViewUrl=/Applet/Chargingpile/CardManager/Page') //跳转
        },
        async toQianbao() {
            let isLogin = await this.octopus.applet.noLoginToPage(this);
            if (!isLogin) return;
            this.octopus.router.jump('/pages/webView/index?webViewUrl=/Applet/Chargingpile/TotalChargeCount/Page') //跳转
        },
        contentHeight() {//此代码为了兼容小程序和H5头部问题
            let content = document.querySelector('.content');
            let header = document.querySelector('.header-nav');
            let footer = document.querySelector('.bottom-nav');
            let contentHeight = window.innerHeight;
            let headerHeight = header.offsetHeight;
            let footerHeight = footer.offsetHeight;
            content.style.height = (contentHeight - headerHeight - footerHeight) +'px'; //设置高度
        },
        getMoney() {
            this.octopus.request.api.post("/Octopus/Engine/List",{
                "id":626,
                "cellData":[
                    {"name":"Balance"},
                    {"name":"ID","filterKey":"=","filterValue":this.octopus.passport.id}  //用户ID
                ]
            },(res) => {
                this.Balance = res.content.queryData[0].Balance; //金额
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Applet/Chargingpile/Mine/Page.vue